import { Variants } from 'motion/react'

export const fadeInUp: Variants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
      delay: 0.8
    }
  }
}

export const scaleIn: Variants = {
  hidden: {
    opacity: 0,
    scale: 0.95
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1]
    }
  }
}

export const staggerContainer: Variants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0,
      delayChildren: 0
    }
  }
}

export const revealViewport = {
  once: true,
  margin: '-100px'
}

export const imageHoverVariants: Variants = {
  rest: {
    scale: 1,
    transition: {
      duration: 0.3,
      ease: [0.22, 1, 0.36, 1]
    }
  },
  hover: {
    scale: 1.05,
    transition: {
      duration: 0.3,
      ease: [0.22, 1, 0.36, 1]
    }
  }
}

/** Reveal without absolute cover-shift — text stays in document flow. */
export const imageRevealVariants = (
  textPosition: 'top' | 'bottom'
): Variants => {
  const fromY = textPosition === 'top' ? 48 : -48
  const transition = {
    duration: 1,
    ease: [0.22, 1, 0.36, 1] as const,
    delay: 1
  }

  return {
    hidden: {
      opacity: 0,
      y: fromY
    },
    visible: {
      opacity: 1,
      y: 0,
      transition
    }
  }
}
